export const settings = {
  siteName: process.env.REACT_APP_TITLE,
  dashboardRoute: "/",
  hasPublicPage: false,
  API_URL: process.env.REACT_APP_API_URL,
  CUSTOM_PROVIDER: process.env.REACT_APP_CUSTOM_PROVIDER,
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  TOKEN: process.env.REACT_APP_TOKEN,
  DOMAIN: process.env.REACT_APP_DOMAIN,
  REDIRECT_MOBILE: process.env.REACT_APP_REDIRECT_MOBILE,
  perPage: 10,
  pagination: {
    pageRangeDisplayed: 3,
    hideDisabled: true,
    hideFirstLastPages: false,
    hideNavigation: true,
    linkClassFirst: "arrow first",
    linkClassPrev: "arrow prev",
    linkClassNext: "arrow next",
    linkClassLast: "arrow last",
  },
  ASSETS_URL: process.env.REACT_APP_ASSETS_URL,
  phoneNumber: "553135461210",
};
